import React, { useEffect, useState } from 'react'
import { portal } from '../portalApi.js'
import { currentCompany, switchCompany } from '../company.js'

// 사이드바 맨 위에서 지금 보고 있는 회사를 알려 주고, 볼 수 있는 회사가 여럿이면 바꾼다.
//
// 어느 회사인지가 늘 보여야 한다. 화면은 네 회사가 똑같이 생겼고 숫자만 다르기 때문에,
// 여기가 비어 있으면 남의 회사 장부를 자기 것으로 알고 볼 수 있다.
//
// 바꾸면 주소가 바뀌면서 페이지를 다시 연다. 화면만 갈아 끼우면 이미 받아 둔 이전 회사
// 데이터가 섞인다.

export default function CompanySwitcher() {
  const [list, setList] = useState(null)
  const code = currentCompany()

  useEffect(() => {
    portal.get('/api/meta/companies')
      .then((d) => setList(d.companies || []))
      .catch(() => setList([]))
  }, [])

  const 지금 = list?.find((c) => c.code === code)
  const 이름 = 지금?.name || (list === null ? '' : '알 수 없는 회사')
  const 색 = 지금?.accent

  // 아직 못 받았으면 자리만 잡아 둔다 - 회사 이름이 깜빡이며 바뀌면 잘못 읽기 쉽다
  if (list === null) {
    return <div className="muted" style={{ fontSize: 12, margin: '0 8px 10px' }}>&nbsp;</div>
  }

  if (list.length <= 1) {
    return (
      <div className="muted" style={{ fontSize: 12, margin: '0 8px 10px' }}>
        {이름 || '주식회사 에르모어'}
      </div>
    )
  }

  return (
    <div style={{ margin: '0 8px 10px', display: 'flex', alignItems: 'center', gap: 6 }}>
      {색 && (
        <span style={{ width: 8, height: 8, borderRadius: 2, background: 색, flexShrink: 0 }} />
      )}
      <select
        value={code}
        title="보고 있는 회사입니다. 바꾸면 그 회사 장부로 다시 엽니다."
        style={{ fontSize: 12, flex: 1, minWidth: 0 }}
        onChange={(e) => {
          if (e.target.value !== code) switchCompany(e.target.value)
        }}>
        {list.map((c) => (
          <option key={c.code} value={c.code}>
            {c.name}{c.type && c.type !== '본사' ? ` · ${c.type}` : ''}
          </option>
        ))}
      </select>
    </div>
  )
}
